import { createApp } from "vue";
import { DateHelper, ModalHelper, bootbox } from "../B2bTools";
import hash from "../hash";
import html from "./orderValidate.html";
import htmlEdit from "./orderValidateEdit.html";

import flatpickrVue from "vue-flatpickr-component";
import Store from "../Store";
import { flatPickrConfig, toDate, toPrix } from "./composant/b2bLangue";
import b2bTypeahead from "./composant/b2bTypeahead";

import orderChart from "./orderChart.html";
import orderUnvalidate from "./orderUnvalidate.html";

import {
    ArcElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    Title,
    Tooltip,
} from "chart.js";
import { Doughnut } from "vue-chartjs";

const imagPardefaut = "0000000/0000000_0000_1_*.png";
ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);

const badges = {
    inprogress: { v: "in progress", color: "bg-primary-soft" },
    validated: { v: "Validated", color: "bg-success-soft" },
    confirmed: { v: "Confirmed", color: "bg-warning-soft" },
    exportded: { v: "Exported", color: "bg-secondary-soft" },
    default: { v: "unknown", color: "bg-warning-soft" },
};

function getBadge(u) {
    if (u.status == "10") return badges.inprogress;
    if (u.status == "11") return badges.validated;
    if (u.status == "9") return badges.confirmed;
    return { v: u.status, default: badges.default.color };
}

function nbe(object) {
    let nb = 0;
    for (let key in object) if (object[key]) nb++;
    return nb;
}

const js = {
    url: function (echangeur) {
        echangeur.addAction("b2b.cart.get2", echangeur.hash, "", "order");
        echangeur.addAction("b2b.SaveThe.getByOrder", echangeur.hash, "", "substitute");
    },
    onLoad: function (echangeur) {
        let THIS = this;
        const _id = echangeur.hash._id;

        let wwwflatPickrConfig = Object.assign({}, flatPickrConfig);
        wwwflatPickrConfig.minDate = echangeur.order.toc?.dateStart;
        wwwflatPickrConfig.maxDate = echangeur.order.toc?.dateEnd;
        let idToc = echangeur.order.toc.idToc;

        function enrichieSubstitute(rows, substitutes) {
            rows.forEach((u) => {
                if (substitutes && substitutes.savesthe) {
                    let savetheComment = substitutes.savesthe.find(
                        (uu) => u.reference == uu.reference
                    );
                    if (savetheComment) u.savetheComment = savetheComment.comment;
                }

                if (substitutes && substitutes.rows) {
                    let substitute = substitutes.rows.find(
                        (uu) => u.reference == uu.substitutefor
                    );
                    if (substitute) {
                        u.substitute = substitute;
                        let refInOrder = rows.find(
                            (element) => element.reference == substitute.reference
                        );
                        // A voir avec JP
                        u.substitute.refInOrder =
                            refInOrder && refInOrder.reference.length > 0;
                        //console.log(u.substitute)
                    }
                }
            });
        }

        enrichieSubstitute(echangeur.order.rows, echangeur.substitute);

        const app = createApp({
            data: () => ({
                hash: echangeur.hash,
                order: echangeur.order,

                scTimer: 0,
                scY: 0,

                showBtnScrollJs: false,

                saisie: {
                    clientDmk: echangeur.order.clientDmk,
                    po: echangeur.order.po,
                    dateStart: echangeur.order.dateDeliveryStart,
                    dateEnd: echangeur.order.dateDeliveryEnd,
                    comment1: echangeur.order.comment1,
                },

                wwwflatPickrConfig: wwwflatPickrConfig,

                errors: {},

                stepList: [
                    "Current orders",
                    "Delivery informations",
                    "General conditions",
                    "Verification & validation",
                ],

                toc: echangeur.order.toc,
                actions: echangeur.order.actions,
                isEdit: { order: false, delivery: false },
            }),

            computed: {
                deliveryAddressHeader() {
                    return this.order.adrliv.ad1;
                },
                deliveryAddressBody() {
                    const b = this.order.adrliv;
                    return [b.ad2, b.ad3, b.ad4, b.cpo + " " + b.vil, b.stateV, b.pay]
                        .map((u) => (u == "." ? "" : u))
                        .filter((u) => u);
                },
            },

            methods: {
                back() {
                    hash.fin();
                },

                handleScroll: function () {
                    if (this.scTimer) return;
                    this.scTimer = setTimeout(() => {
                        this.scY = window.scrollY;
                        clearTimeout(this.scTimer);
                        this.scTimer = 0;
                    }, 100);
                },

                toTop: function () {
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    });
                },

                edit(name) {
                    if (!nbe(this.errors) && name == "delivery") {
                        this.isEdit.delivery = this.isEdit.delivery ? false : true;
                    }
                    if (name == "order") this.isEdit.order = this.isEdit.order ? false : true;
                    //this.isEdit[name] = this.isEdit[name] ? false : true;
                },

                async saveOrderInformation() {
                    let error = {};
                    let order = this.order;
                    let saisie = this.saisie;

                    const form = { _id };
                    if (order.po != saisie.po) form.po = saisie.po;
                    if (order.comment1 != saisie.comment1)
                        form.comment1 = saisie.comment1;
                    if (order.clientDmk != saisie.clientDmk)
                        form.clientDmk = saisie.clientDmk;

                    if (!nbe(error)) {
                        const result = await THIS.rest("b2b.order.save", {}, form);
                        if (result.ok) {

                        }
                    }
                },

                async saveDeliveryInformation(saisie) {
                    const errors = {};
                    let order = this.order;

                    const form = {
                        _id,
                        dateDeliveryStart: saisie.dateStart,
                        dateDeliveryEnd: saisie.dateEnd,
                        door: order.door,
                    };

                    if (!saisie.dateEnd) errors.msg = "Required";
                    if (saisie.dateEnd > order.dateEnd)
                        errors.msg = "Date end > date end max";

                    if (!saisie.dateStart) errors.msg = "Required";
                    if (saisie.dateStart < order.dateStart)
                        errors.msg = "Date start < date start min";
                    if (saisie.dateStart && DateHelper.now() > saisie.dateStart)
                        errors.msg = "Date start > now";

                    if (!errors.dateStart && !errors.dateEnd) {
                        let dateNow = DateHelper.now();
                        if (saisie.dateStart > saisie.dateEnd)
                            errors.msg = "Date start > date end";
                        if (dateNow > saisie.dateStart) errors.msg = "Date start < now";
                    }

                    this.errors = errors;

                    if (!nbe(errors)) {
                        const result = await THIS.rest("b2b.order.save", {}, form);
                        if (result.ok) this.isEdit.delivery = false;
                    }
                },

                gotoOrderList() { 
                    if (!echangeur.hash.formLinelist ||  echangeur.hash.formLinelist != "true") {
                         const env = hash.toArray()[0].par.u;
             
                        window.location.href = env ? `#orderList&u=${env}` : "#universe"; 

                    } else { 
                        hash.fin();
                    }

                },

                gotoLinelist() {
                    if (echangeur.hash.formLinelist == "true") {
                        hash.fin();
                    } else {
                        const url = hash.toArray()[0].par.u;
                        window.location.href = url ? `#env&u=${url}` : "#universe";
                    }
                },

                async unvalidateOrder() {
                    const vueParent = this;
                    const modaleApp = createApp({
                        data: function () {
                            return {
                                saisie: { comment: "" },
                            };
                        },
                        methods: {
                            close() {
                                ModalHelper.hide();
                            },
                            async save() {
                                if (this.saisie.comment == "") return;
                                const form = await THIS.rest(
                                    "b2b.order.unvalidate",
                                    { _id, comment: this.saisie.comment },
                                    {}
                                );
                                vueParent.actions = form.actions;
                                vueParent.order.status = form.order.status;
                                ModalHelper.hide();
                            },
                        },
                        mounted() {
                            ModalHelper.show(async function () {
                                modaleApp.unmount();
                            });
                        },
                    });
                    modaleApp.mount(ModalHelper.html(orderUnvalidate).container);
                },

                validateOrder() {
                    hash.lance("orderVerifie", { _ids: _id, ecran: "validate" });
                },

                confirmOrder() {
                    hash.lance("orderVerifie", { _ids: _id, ecran: "confirm" });
                },

                deleteOrder() {
                    hash.chaine("orderVerifie", {
                        _ids: _id,
                        ecran: "delete",
                        from: "un",
                    });
                },

                async pdf() {
                    const t = await THIS.rest("b2b.order.pdf", { _id, version: "" }, {});
                    if (t.url) window.open(t.url);
                },

                async xls(version) {
                    const t = await THIS.rest("b2b.order.xls", { _id, version }, {});
                    if (t.url) window.open(t.url);
                },

                async selectproduct(item) {
                    const row = { reference: item.k };
                    await this.orderEditRow(row);
                    //
                },

                saisietypeahead() {
                    return async function (key) {
                        let array = await THIS.rest("b2b.saisie.typeahead", {
                            _id,
                            k: key,
                            limit: 10,
                            idToc: idToc
                        });
                        return array.map((u) => ({
                            k: u.reference,
                            v: u.v + " (" + u.reference + " / " + u.familyV + " / " + u.macrofamily + " )",
                        }));
                    };
                },

                async statsOrder() {
                    const result = await THIS.rest("b2b.orders.stats", { _ids: [_id] });

                    const modaleApp = createApp({
                        data: function () {
                            return {
                                tableaux: [
                                    construitTableau(result.stats.collectiontype, {
                                        caption: "Collection type",
                                    }),
                                    construitTableau(result.stats.deliverytheme, {
                                        caption: "Delivery Theme",
                                    }),
                                    construitTableau(result.stats.department, {
                                        caption: "Product Department",
                                    }),
                                    construitTableau(result.stats.familyV, { caption: "Family" }),
                                    construitTableau(result.stats.couG, {
                                        caption: "Generic Color",
                                    }),
                                    construitTableau(result.stats.heel, { caption: "Heels" }),
                                    construitTableau(result.stats.desc, {
                                        caption: "Short Desc",
                                    }),
                                ],
                                triActuel: "",
                                choixChart: "qt",
                            };
                        },
                        components: { Doughnut },

                        methods: {
                            close: function () {
                                ModalHelper.hide();
                            },
                            toPrix(value, devise) {
                                return toPrix(value, devise);
                            },
                            pourcent(qt, totalQt) {
                                if (!totalQt) return " ";
                                return ((qt / totalQt) * 100).toFixed(0) + " %";
                            },

                            toChart(array) {
                                // https://vue-chartjs.org/examples/#vue-3-charts
                                let data = {
                                    labels: [],
                                    datasets: [
                                        {
                                            data: [],
                                            backgroundColor: colors,
                                        },
                                    ],
                                };

                                for (const item of array) {
                                    if (item[this.choixChart] > 0) {
                                        // @ts-ignore
                                        data.labels.push(item.v || item.key);
                                        // @ts-ignore
                                        data.datasets[0].data.push(item[this.choixChart]);
                                    }
                                }
                                return data;
                            },

                            tri(tableau, name) {
                                tableau.sens = this.triActuel == name ? -tableau.sens : 1;
                                if (name == "qt")
                                    tableau.rows.sort((a, b) => (b.qt - a.qt) * tableau.sens);
                                if (name == "ht")
                                    tableau.rows.sort((a, b) => (b.ht - a.ht) * tableau.sens);
                                if (name == "nb")
                                    tableau.rows.sort((a, b) => (b.nb - a.nb) * tableau.sens);
                                this.triActuel = name;
                                this.choixChart = name;
                            },
                        },

                        mounted() {
                            ModalHelper.show(async function () {
                                modaleApp.unmount();
                            });
                        },
                    });
                    // @ts-ignore
                    modaleApp.mount(ModalHelper.html(orderChart).container);
                },

                urlImg(img) {
                    return (
                        "download/product/" +
                        (img ? img.replace("*", "S") : imagPardefaut.replace("*", "S"))
                    );
                },

                toDate(value) {
                    return toDate(value);
                },

                toPrix(value, devise) {
                    return toPrix(value, devise);
                },

                async orderDeleteRow(row) {
                    const vueParent = this;
                    bootbox.confirm(
                        {
                            title: "Delete product",
                            message: `Are you sure to delete ${row.v} ?`,
                        },
                        async function () {
                            let data = await THIS.rest("b2b.saisie.deleteProduct", {
                                _id,
                                reference: row.reference,
                            });
                            enrichieSubstitute(data.rows, echangeur.substitute);

                            vueParent.order.rows = data.rows;
                            vueParent.order.totaux = data.totaux;
                            vueParent.actions = data.actions;
                        }
                    );
                },

                async orderEditRow(row) {
                    const vueParent = this;
                    const currentorderid = _id;

                    // function buildUvcSaisies(product, codestock) {
                    //     const uvcSaisies = [];
                    //     // spécial LBT 
                    //     let cou = product.cou[0].k;
                    //     let productstocks = [];

                    //     if (product.stock && product.stock.rows && product.stock.rows) productstocks = product.stock.rows;

                    //     product.tai.forEach(tail => {
                    //         const k = cou + "_" + tail.k;
                    //         let uvc = product.uvc[k];
                    //         let saisie = product.ct[k];
                    //         uvc.qt = (saisie && saisie.qt) ? saisie.qt : 0;

                    //         if (codestock && productstocks.length > 0) {
                    //             let stocksbycode = productstocks[0].stock.filter(s => s.codestock == codestock);
                    //             //
                    //             //console.log(stocksbycode)
                    //             uvc.ostock = {};
                    //             uvc.ostock.stockdispo = 0;
                    //             uvc.ostock.stockreel = 0;
                    //             uvc.ostock.sasissable = 0;
                    //             uvc.ostock.stockdispo = 0;
                    //             //
                    //             if (stocksbycode.length > 0) {
                    //                 //
                    //                 let a = stocksbycode.find(s => s.ean == uvc.ean);
                    //                 if (!a) a = {}
                    //                 //
                    //                 uvc.ostock = {};
                    //                 uvc.ostock.stockreel = a.stockreel || 0;
                    //                 uvc.ostock.stockdispo = a.stockdispo || 0;
                    //                 uvc.ostock.sasissable = uvc.ostock.stockdispo + uvc.qt;
                    //             }
                    //         }

                    //         uvcSaisies.push(uvc)
                    //     })
                    //     return uvcSaisies;
                    // }
                    function buildUvcSaisies(product,codestock) {
                        const uvcSaisies = [];
                        // spécial LBT 
                        let cou = product.cou[0].k;
                        let productstocks = []; 
                      
                        if(product.stock && product.stock.rows && product.stock.rows) productstocks = product.stock.rows;
                        if(productstocks.filter(s => s.codestock == codestock).length > 0) productstocks = productstocks.filter(s => s.codestock == codestock)
                      
                      
                        console.log(`🏗️ codestock`,codestock)
                        console.log(`🏗️ productstocks`,productstocks)
                      
                        product.tai.forEach(tail => {
                          const k = cou + "_" + tail.k;
                          let uvc = product.uvc[k];
                          let saisie = product.ct[k];
                          uvc.qt = (saisie && saisie.qt) ? saisie.qt : 0;
                      
                          if (codestock && productstocks.length > 0) {
                            console.log(`🏗️ buildUvcSaisies  productstocks[0].stock`, productstocks[0].stock)
                            let stocksbycode = productstocks[0].stock.filter(s => s.codestock == codestock);
                            //
                            //console.log(stocksbycode)
                            uvc.ostock = {};
                            uvc.ostock.stockdispo = 0;
                            uvc.ostock.stockreel  = 0;
                            uvc.ostock.sasissable = 0;
                            uvc.ostock.stockdispo = 0;
                            //
                            if (stocksbycode.length > 0) {
                              //
                              let a = stocksbycode.find(s => s.ean == uvc.ean);
                              if (!a) a = {}
                              //
                              uvc.ostock = {};
                              uvc.ostock.stockreel = a.stockreel || 0;
                              uvc.ostock.stockdispo = a.stockdispo || 0;
                              uvc.ostock.sasissable = uvc.ostock.stockdispo + uvc.qt;
                              
                            }
                          }
                      
                          uvcSaisies.push(uvc)
                        })
                        return uvcSaisies;
                      }
                    const env = hash.toArray()[0].par.u;
                    const product = await THIS.rest("b2b.saisie.get", {
                        env: env,
                        _id: currentorderid,
                        reference: row.reference,
                    });

                    //const codeStock = vueParent.order.onstock ? [product.stock.lcodestock] : [];
                    const codeStock = vueParent.order.codestock || null
                    const onstock = vueParent.order.onstock
                    const uvcSaisies = buildUvcSaisies(product, codeStock);

                    row.departmentV = product.departmentV;
                    row.v = product.v;
                    row.familyV = product.familyV;
                    row.couV = product.couV;

                    const onSuccess = function (data) {
                        vueParent.order.rows = data.rows;
                        vueParent.order.totaux = data.totaux;
                        vueParent.actions = data.actions;
                        // row.qt = data.row.totaux.qt;
                        // row.ht = data.row.totaux.ht;
                        // //
                        //vueParent.totaux = data.totaux;
                        Store.set("orderChange", new Date());
                    };
                    // row.totaux.ht
                    //
                    const modaleApp = createApp({
                        data: () => ({
                            onstock,
                            codeStock,
                            currentorderid, // vient du cart
                            row: row, // vient du cart
                            devise: echangeur.order.devise,
                            product: {
                                _id: product._id,
                                reference: product.reference,
                                verifie: product.verifie,
                                v: product.forV,
                                prixRetail: product.prixRetail,
                                savethe: product.savethe,
                            },
                            saisie: {
                                uvc: uvcSaisies,
                                isGlobal: product.isGlobal,
                                qtGlobal: product.glob.qt,
                            },
                            // Si taille unique pas de saisie global qty
                            isTailleunique: product.tai.length === 1, // ne fait pas apparaitre global quantity
                            totaux: {
                                qt: 0,
                                ht: 0,
                                prix: 0,
                            },
                            totalSaisieQt: 0,
                            totalArticle: {
                                total: null,
                                global: null,
                            },
                        }),
                        methods: {

                            toPrix(value, devise) {
                                return toPrix(value, devise);
                            },

                            saisieClass(saisie, item) {
                                const isInvalid = item.qt > parseInt(item.ostock?.sasissable) || item.qt < 0 ? 'is-invalid' : ''
                                const disable = saisie.isGlobal || ((this.onstock && !item.ostock) || (item.ostock && item.ostock.sasissable == 0)) ? 'bg-light' : '_tai'
                                return `form-control text-center px-0 m-0 input-number ${isInvalid} ${disable}`;
                            },

                            saisieStock(item) {
                                return (!item.ostock || item.ostock.sasissable == 0) ? "-" : item.ostock.sasissable
                            },

                            toPrixOrder(value) {
                                if (vueParent.order) {
                                    return toPrix(value, vueParent.order.devise);
                                }
                            },

                            recalc() {
                                if (this.isTailleunique) {
                                    if (this.saisie.isGlobal) {
                                        this.saisie.isGlobal = false;
                                        this.saisie.uvc[0].qt = this.saisie.qtGlobal;
                                    }
                                }
                                let totQt = 0;
                                let totHt = 0;
                                let prixGlobal = 0;
                                for (const uvc of this.saisie.uvc) {
                                    if (uvc.qt) {
                                        totQt += uvc.qt;
                                        totHt += uvc.qt * uvc.prix.prix;
                                    } else {
                                        uvc.qt = "";
                                    }
                                    if (!prixGlobal) prixGlobal = uvc.prix; // prix global, on prend le 1er prix
                                }
                                this.totalSaisieQt = totQt;

                                if (this.saisie.isGlobal) {
                                    this.totaux.qt = this.saisie.qtGlobal ? this.saisie.qtGlobal : 0;
                                    this.totaux.prix = prixGlobal;
                                    this.totaux.ht = this.saisie.qtGlobal
                                        ? this.saisie.qtGlobal * prixGlobal
                                        : 0;
                                } else {
                                    this.totaux.qt = totQt;
                                    this.totaux.prix = prixGlobal;
                                    this.totaux.ht = totHt;
                                }
                            },

                            switchGlobal(value) {
                                this.saisie.isGlobal = value;
                                this.recalc();
                            },
                            greetGlobal() {
                                this.switchGlobal(true);
                            },
                            greetTotal() {
                                this.switchGlobal(false);
                            },
                            changeQt(uvc) {
                                const qt = parseInt(uvc.qt);
                                uvc.qt = qt ? qt : "";
                                this.recalc();
                            },
                            changeGlobal() {
                                const qt = parseInt(this.saisie.qtGlobal);
                                this.saisie.qtGlobal = qt ? qt : "";
                                this.recalc();
                            },
                            close() {
                                ModalHelper.hide();
                            },
                            onPressEnter() {
                                this.submit();
                            },
                            async submit() {

                                const isInvalid = document.querySelector('.is-invalid')
                                if (isInvalid !== null) return

                                if (this.product.verifie.ok) {
                                    const form = {
                                        _id: currentorderid,
                                        reference: this.product.reference,
                                        tc: this.saisie.uvc.map((u) => ({
                                            cou: u.cou,
                                            tai: u.tai,
                                            qt: u.qt,
                                            uvc: u.uvc,
                                        })),
                                        isGlobal: this.saisie.isGlobal,
                                        qtGlobal: this.saisie.qtGlobal,
                                    };
                                    //
                                    //
                                    let data = await THIS.rest("b2b.saisie.save", {}, form);
                                    enrichieSubstitute(data.rows, echangeur.substitute);

                                    Store.get("updateTotaux")(data);
                                    //
                                    /* console.log("retour de saisie", data) */
                                    onSuccess(data);
                                    this.close();
                                }
                            },
                            urlImg(img) {
                                return (
                                    "download/product/" +
                                    (img
                                        ? img.replace("*", "S")
                                        : imagPardefaut.replace("*", "S"))
                                );
                            },
                        },
                        mounted() {
                            ModalHelper.show(function (data) {
                                modaleApp.unmount();
                            });
                            this.recalc();
                            //
                            // const premier = (this.saisie.isGlobal) ? this.$refs.global : this.$refs.saisie[0];
                            // this.$nextTick( function() {
                            //     console.log( "set focus",premier )
                            //     premier.focus();
                            // })
                            //

                            const moveArrowInput = () => {
                                const inputs = document.querySelectorAll("._tabSaisie ._tai");

                                inputs.forEach((input, index) => {
                                    input.addEventListener("keydown", function (e) {
                                        const key = e.which || e.keyCode;

                                        if (key === 39 /* Droite */) {
                                            e.preventDefault();
                                            if (index + 1 < inputs.length) {
                                                inputs[index + 1].setSelectionRange(
                                                    0,
                                                    inputs[index + 1].value.length
                                                );
                                                inputs[index + 1].focus();
                                            }
                                        }
                                        if (key === 37 /* Gauche */) {
                                            e.preventDefault();
                                            if (index > 0) {
                                                inputs[index - 1].setSelectionRange(
                                                    0,
                                                    inputs[index - 1].value.length
                                                );
                                                inputs[index - 1].focus();
                                            }
                                        }
                                    });
                                });
                            };
                            moveArrowInput();
                        },
                    });
                    modaleApp.mount(ModalHelper.html(htmlEdit).container);
                },

                showTab(id) {
                    this.tab = id;
                },

                getBadge(u) {
                    return getBadge(u);
                },
            },

            components: {
                "type-ahead": b2bTypeahead,
                "flatpickr-vue": flatpickrVue,
            },

            mounted() {
                window.addEventListener("scroll", this.handleScroll);
            },
        });

        app.mount(THIS.c$("._vueChargement")[0]);
    },
};

export default {
    orderValidate: { js, html },
};

function construitTableau(array, options) {
    const total = { qt: 0, ht: 0, nb: 0 };

    for (const item of array) {
        total.qt += item.qt;
        total.ht += item.ht;
        total.nb += item.nb;
    }

    const retour = Object.assign({}, options);
    retour.rows = array;
    retour.total = total;
    retour.tri = "";
    retour.sens = "";
    return retour;
}

const colors = [
    "#2196F3",
    "#E3F2FD",
    "#BBDEFB",
    "#90CAF9",
    "#64B5F6",
    "#42A5F5",
    "#1E88E5",
    "#1976D2",
    "#1565C0",
    "#0D47A1",
    "#3F51B5",
    "#E8EAF6",
    "#C5CAE9",
    "#9FA8DA",
    "#7986CB",
    "#5C6BC0",
    "#3949AB",
    "#303F9F",
    "#283593",
    "#1A237E",
];

// function buildUvcSaisies(product, cou, stocks=[],codestock=null) {
//     const uvcSaisies = [];
//     let stock = [];
//     if(codestock) {
//     stock = stocks.filter((s) => s.codestock==codestock);
//     }
//     for (const [i, tai] of product.tai.entries()) {
//     if (!tai.h) {
//         //@@@test pour enlever les colis
//         const key = cou.k + "_" + tai.k;
//         const u = product.uvc[key];

//         if (u) {
//         let libstock = '';
//         if(stock) {
//             libstock = '-';
//             const st  = stock.filter((s) => s.ean==u.ean);
//             if(st[0] && st[0].stockdispo && st[0].stockdispo>=1) {
//             libstock = st[0].stockdispo;
//             }
//         }
//         uvcSaisies.push({
//             cou: u.cou,
//             tai: u.tai,
//             cond: u.cond,
//             bloque: u.bloque,
//             uvc: u.uvc,
//             qt: product.ct[key] ? product.ct[key].qt : 0,
//             prix: u.prix ? u.prix.prix : 0,
//             ean: u.ean,
//             stock: libstock
//         });
//         } else {
//         uvcSaisies.push({
//             cou: cou.k,
//             tai: tai.k,
//         });
//         }
//     }
//     }
//     return uvcSaisies;
// }
